export const getSupressAttributes = (sensitive?: boolean): { "data-hj-suppress"?: string } => (sensitive ? { "data-hj-suppress": "" } : {});
